// Portal Pricing Exemptions API Service — standing per-ship-to pricing
// overrides (read-only reference data for CSRs).

import api from './api';

export interface PricingOverrideRow {
  id: string;
  customer_no: string;
  customer_name: string | null;
  ship_to_code: string | null;
  ship_to_city: string | null;
  ship_to_state: string | null;
  pricing_customer_no: string;
  pricing_customer_name: string | null;
  reason: string;
  authorized_by: string | null;
  requested_by: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PricingOverrideListResponse {
  overrides: PricingOverrideRow[];
  total: number;
}

export const portalPricingOverrideService = {
  /** List standing pricing exemptions, newest first. */
  listOverrides: async (
    includeInactive = false,
  ): Promise<PricingOverrideListResponse> => {
    const response = await api.get<PricingOverrideListResponse>(
      '/portal/pricing-overrides',
      { params: includeInactive ? { include_inactive: true } : {} },
    );
    return response.data;
  },
};
